export const COMMENT_REASON_CODES = [
    'Reclass',
    'Re-weight',
    'Detention',
    'Pricing Correction',
    'Rate Negotiation',
    'Accessorial Adjustment',
    'Fuel Adjustment',
    'Service Upgrade',
    'Damage Claim',
    'Other',
];

export const COLUMNS = [
    {
        key: 'type',
        label: 'Type',
        align: 'left',
        width: 2,
    },
    {
        label: 'Rate',
        key: 'rate',
        align: 'center',
        width: 2,
    },
    {
        label: 'Quantity',
        key: 'quantity',
        align: 'center',
        width: 1,
    },
    {
        label: 'Product/Service',
        key: 'qbo_tag',
    },
    {
        label: 'Comment',
        key: 'comment',
        width: 2,
    },
    {
        label: 'Total',
        key: 'total',
        align: 'right',
        width: 1,
    },
];

export const FIXED_CHARGES = ['base_charge', 'margin_flat_charge', 'margin_rate_charge', 'cc_transaction_charge'];

export const PERSPECTIVE_MAP = {
    internal: {
        title: 'Rate Breakdown',
        role: 'INTERNAL',
        id: 'carrier_id',
        rate: 'order_revenue',
        client: 'order_carrier',
        pricing_override_id: 'onward_rate_override_id',
        pricing_override: 'onward_rate_override',
        invoice_id: 'carrier_invoice_id',
        editable_with_invoice: true,
        breakdown: 'internalBreakdown',
        overrides: 'internal',
        baseOverride: 'order_revenue_override',
    },
    shipper: {
        title: 'Shipper Rate Breakdown',
        role: 'SHIPPER',
        id: 'shipper_id',
        rate: 'shipper_rate',
        client: 'order_shipper',
        pricing_override_id: 'shipper_rate_override_id',
        pricing_override: 'shipper_rate_override',
        invoice_id: 'shipper_invoice_id',
        editable_with_invoice: true,
        breakdown: 'shipperBreakdown',
        overrides: 'shipper',
        baseOverride: 'admin_shipper_rate_override',
    },
    carrier: {
        title: 'Carrier Rate Breakdown',
        role: 'CARRIER',
        id: 'carrier_id',
        rate: 'carrier_rate',
        client: 'order_carrier',
        pricing_override_id: 'carrier_rate_override_id',
        pricing_override: 'carrier_rate_override',
        invoice_id: 'carrier_invoice_id',
        editable_with_invoice: false,
        breakdown: 'carrierBreakdown',
        overrides: 'carrier',
        baseOverride: 'admin_carrier_rate_override',
    },
    mm_shipper: {
        title: 'MM Shipper Rate Breakdown',
        role: 'SHIPPER',
        id: 'shipper_id',
        rate: 'middle_mile_shipper_rate',
        client: 'order_shipper',
        pricing_override_id: 'middle_mile_shipper_rate_override_id',
        pricing_override: 'middle_mile_shipper_rate_override',
        invoice_id: 'shipper_invoice_id',
        editable_with_invoice: true,
        breakdown: 'mmShipperBreakdown',
        overrides: 'mmShipper',
        baseOverride: 'admin_middle_mile_shipper_rate_override',
    },
    mm_carrier: {
        title: 'MM Carrier Rate Breakdown',
        role: 'MM_CARRIER',
        id: 'middle_mile_carrier_id',
        rate: 'middle_mile_carrier_rate',
        client: 'order_middle_mile_carrier',
        pricing_override_id: 'middle_mile_carrier_rate_override_id',
        pricing_override: 'middle_mile_carrier_rate_override',
        invoice_id: 'middle_mile_carrier_invoice_id',
        editable_with_invoice: false,
        breakdown: 'mmCarrierBreakdown',
        overrides: 'mmCarrier',
        baseOverride: 'admin_middle_mile_carrier_rate_override',
    },
    wh_shipper: {
        title: 'WH Shipper Rate Breakdown',
        role: 'SHIPPER',
        id: 'shipper_id',
        rate: 'warehouse_shipper_rate',
        client: 'order_shipper',
        pricing_override_id: 'warehouse_shipper_rate_override_id',
        pricing_override: 'warehouse_shipper_rate_override',
        invoice_id: 'shipper_invoice_id',
        editable_with_invoice: true,
        breakdown: 'whShipperBreakdown',
        overrides: 'whShipper',
        baseOverride: 'admin_warehouse_shipper_rate_override',
    },
    wh_carrier: {
        title: 'WH Carrier Rate Breakdown',
        role: 'CARRIER',
        id: 'carrier_id',
        rate: 'warehouse_carrier_rate',
        client: 'order_carrier',
        pricing_override_id: 'warehouse_carrier_rate_override_id',
        pricing_override: 'warehouse_carrier_rate_override',
        invoice_id: 'carrier_invoice_id',
        editable_with_invoice: false,
        breakdown: 'whCarrierBreakdown',
        overrides: 'whCarrier',
        baseOverride: 'admin_warehouse_carrier_rate_override',
    },
    contractor: {
        title: 'Contractor Rate Breakdown',
        role: 'CONTRACTOR',
        id: 'contractor_id',
        rate: 'contractor_rate',
        client: 'order_contractor',
        pricing_override_id: 'contractor_rate_override_id',
        pricing_override: 'contractor_rate_override',
        invoice_id: 'contractor_invoice_id',
        editable_with_invoice: false,
        breakdown: 'contractorBreakdown',
        overrides: 'contractor',
        baseOverride: 'admin_contractor_rate_override',
    },
};

export const PRICING_FIELDS = [
    'order_revenue',
    'shipper_rate',
    'carrier_rate',
    'middle_mile_shipper_rate',
    'middle_mile_carrier_rate',
    'warehouse_shipper_rate',
    'warehouse_carrier_rate',
    'contractor_rate',
    'order_revenue_override',
    'admin_shipper_rate_override',
    'admin_carrier_rate_override',
    'admin_contractor_rate_override',
    'admin_middle_mile_shipper_rate_override',
    'admin_middle_mile_carrier_rate_override',
    'admin_warehouse_shipper_rate_override',
    'admin_warehouse_carrier_rate_override',
    'onward_rate_override_id',
    'shipper_rate_override_id',
    'carrier_rate_override_id',
    'middle_mile_shipper_rate_override_id',
    'middle_mile_carrier_rate_override_id',
    'warehouse_shipper_rate_override_id',
    'warehouse_carrier_rate_override_id',
    'contractor_rate_override_id',
    'price_breakdown',
    'order_revenue_adjustments',
];
